(function($){
$(document).ready(function() {

    $("#recherche-ressources [name='categorie']").on("change", function(e) {
      e.preventDefault();
        var categorie=$(this).val();
        $("#recherche-ressources [name='type']").html("<option value=\"\">Type de ressource</option>");
        $.ajax({
            url: '/inc/xhr/actions.php?action=get_type_from_categorie&categorie='+categorie,
            success: function(data){
                if(data!='')
                  $("#recherche-ressources [name='type']").html(data);
            }
        });
    });

    $('.menu-liste-carte [role="tab"]').on('click', function(e){
        fermer_popin();
        $('#affichage-carte').removeClass('heightzero');
    });

    if ( $('.popinmessage').html() != undefined && $('.popinmessage').html().trim() != '' ) {
        $.popin.alert( {
            type: $('.popinmessage').data('type'),
            title: $('.popinmessage').data('title'),
            message: $('.popinmessage').html(),
            button: $('.popinmessage').data('button')
        });
    }

    $('.select-langues').on('change', function() {
        window.location.href=$(this).val();
    });


    $('.photos-produit').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.vignettes-slider'
    });


    $('.vignettes-slider').slick({
        arrows: true,
        dots: false,
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.photos-produit',
        cssEase: 'ease-in-out',
    });

    $('.liste-actus').slick({
        autoplay: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        focusOnSelect: true,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        fade: true,
        cssEase: 'ease-out',
    });

    $('.autres-produits-slider').slick({
        arrows: true,
        // centerMode: true,
        centerPadding: '40px',
        slidesToScroll: 5,
        slidesToShow: 5,
        // variableWidth: true,
        responsive: [
          {
            // centerMode: true,
            breakpoint: 1240,
            settings: {
              // arrows: true,
              slidesToScroll: 4,
              slidesToShow: 4
            }
          },
          {
            // centerMode: true,
            breakpoint: 1024,
            settings: {
              // arrows: true,
              slidesToScroll: 3,
              slidesToShow: 3
            }
          },
          {
            // centerMode: true,
            breakpoint: 768,
            settings: {
              // arrows: true,
              slidesToScroll: 2,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            // centerMode: true,
            settings: {
              // arrows: true,
              slidesToScroll: 1,
              slidesToShow: 1
            }
          }
        ]
    });

})
})(jQuery);
